import useAppModernisation from "../../hooks/useAppModernisation";
import Search from "../search/search";
import EnhancedSearchResultsPageRouter from "./EnhancedSearchResultsPageRouter";
import EnhancedSearchResultsPageApp from "./EnhancedSearchResultsPageApp";
const SearchRouter = () => {
  const { isEnhancedSearchEnabled, isAppMode, isWebModernisationEnabled } =
    useAppModernisation();

  return isEnhancedSearchEnabled ? (
    isAppMode ? (
      <EnhancedSearchResultsPageApp
        isWebModernisationEnabled={isWebModernisationEnabled}
        isAppMode={isAppMode}
      />
    ) : (
      <EnhancedSearchResultsPageRouter />
    )
  ) : (
    <Search />
  );
};

export default SearchRouter;
